module.exports = __webpack_public_path__ + "static/img/kwh_item_image2.9f8f8f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/kwh_item_image2.png
// module id = Wr4n
// module chunks = 1